import { variables } from './variables.ts';

/**
 * Type-safe constraint to enforce an environment variable to be
 * available and return its value, or throw otherwise.
 */
const env = <
  TKey extends keyof typeof variables,
  TEnforce extends boolean | undefined = undefined,
  TResult = TEnforce extends false ? string | undefined : string,
>(
  name: TKey,
  enforce?: TEnforce,
): TResult => {
  if (enforce !== false && typeof variables[name] === 'undefined') {
    throw new Error(`Missing ${name} environment variable`);
  }

  return variables[name] as TResult;
};

/**
 * Returns true if the passed in env variable is set to 'true'.
 * @param key - The key of the environment variable to check.
 * @returns true if the environment variable is enabled, false otherwise.
 */
function isEnvEnabled(key: keyof typeof variables, enforce = true): boolean {
  return env(key, enforce) === 'true';
}

export { env, isEnvEnabled };
